var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-page",
    {
      attrs: {
        "show-grid": _vm.showGrid,
        "grid-settings": _vm.layout.EditorSettings.GridSettings,
        "zoom-level": _vm.zoomLevel,
        "page-settings": _vm.layout.getRequirementsPageSettings(),
      },
    },
    [
      _c("app-requirements", {
        attrs: {
          "example-document": _vm.exampleDocument,
          lang: _vm.lang,
          layout: _vm.layout,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }